var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcBaselineAccountCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3333 1.99997C5.73333 1.99997 2 5.7333 2 10.3333C2 14.9333 5.73333 18.6666 10.3333 18.6666C14.9333 18.6666 18.6667 14.9333 18.6667 10.3333C18.6667 5.7333 14.9333 1.99997 10.3333 1.99997ZM10.3333 5.3333C11.9417 5.3333 13.25 6.64164 13.25 8.24997C13.25 9.8583 11.9417 11.1666 10.3333 11.1666C8.725 11.1666 7.41667 9.8583 7.41667 8.24997C7.41667 6.64164 8.725 5.3333 10.3333 5.3333ZM10.3333 17C8.64167 17 6.64167 16.3166 5.21667 14.6C6.67634 13.4547 8.47802 12.8323 10.3333 12.8323C12.1886 12.8323 13.9903 13.4547 15.45 14.6C14.025 16.3166 12.025 17 10.3333 17Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcBaselineAccountCircle);
export default __webpack_public_path__ + "static/media/ic_baseline-account-circle.a8b3691eb881039addf09af214eb331f.svg";
export { ForwardRef as ReactComponent };